"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    DpUnattemptedStudentModal: {
        title: 'Students without a submission attempt',
        columnName: 'Name',
    },
};
